import { useQuery } from "react-query";
import { getScoring, GroupType } from "../../api/admin/score";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { SAdminSearchScore } from "../../styles/AdminSearchScore";
import { QueryLoader } from "../Loader";
import { ScoreTable } from "./Table/Table";

export type ScoreType = {
	boost: {
		[key: string]: number;
	};
};

type AdminSearchScoreProps = {
	group: GroupType;
};
export const AdminSearchScore = (props: AdminSearchScoreProps) => {
	const { group } = props;

	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data, refetch } = useQuery<ScoreType>(`boost-${group}`, () => getScoring(axiosPrivate, group));

	if (isLoading) {
		return <QueryLoader />;
	}
	if (isError) {
		console.error(error);
		return <>something went wrong</>;
	}

	if (!data) return <div></div>;

	return (
		<SAdminSearchScore>
			<ScoreTable score={data} refetch={refetch} group={group} />
		</SAdminSearchScore>
	);
};
